module.exports = __webpack_public_path__ + "img/q2.4bfe8023.png";